import type { FiltersCollection } from '../filtersCollectionsRegistry'
import { getDatabaseFilterEntries } from './entries'
import { getDatabaseProducersFiltersCollection } from './producers'
import { getDatabaseProducersDuplicatesFiltersCollection } from './producersDuplicates'
import { getDatabaseBrandsFiltersCollection } from './brands'
import { getDatabaseWinesFiltersCollection } from './wines'
import { getDatabaseGeoIndicationFiltersCollection } from './geoIndication'
import { getDatabaseExhibitionsFiltersCollection } from './exhibitions'
import { getDatabaseKindOfWineFiltersCollection } from './kindOfWine'
import { getDatabaseSpecClasConditionFiltersCollection } from './specClasCondition'

export {
  getDatabaseFilterEntries,
  getDatabaseProducersFiltersCollection,
  getDatabaseProducersDuplicatesFiltersCollection,
  getDatabaseBrandsFiltersCollection,
  getDatabaseWinesFiltersCollection,
  getDatabaseGeoIndicationFiltersCollection,
  getDatabaseExhibitionsFiltersCollection,
  getDatabaseKindOfWineFiltersCollection,
  getDatabaseSpecClasConditionFiltersCollection,
}

// Полный словарь как массив. Используется потребителями, которым нужен
// поиск по filterName (хук useDatabaseFiltersInputs, AppliedFilters в Header)
export const getDatabaseFiltersCollection = (): FiltersCollection =>
  Object.values(getDatabaseFilterEntries())
